import React, { useState } from "react";
import PropTypes from "prop-types";
import "./news-feed-item.styles.scss";
import classNames from "classnames";
import { generateNearlyUniqueID } from "common/uuid";

const propTypes = {
  pageIcon: PropTypes.string.isRequired,
  pageName: PropTypes.string.isRequired,
  domain: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  message: PropTypes.string,
  body: PropTypes.string,
  mediaSrc: PropTypes.string.isRequired,
  isVideo: PropTypes.bool,
  isBlurred: PropTypes.bool,
  children: PropTypes.node
};

const NewsFeedItem = ({
  pageIcon,
  pageName,
  domain = "www.adwerx.com",
  title = "Title goes here",
  subtitle = "Sponsored",
  body = "Body goes here",
  message = "Message goes here",
  mediaSrc,
  isVideo = false,
  isBlurred = false,
  children = null
}) => {
  const uuid = generateNearlyUniqueID();
  const [isLoaded, setIsLoaded] = useState(children);

  return (
    <div className={classNames(["newsfeed-item", { "newsfeed-item--blurred": isBlurred }])}>
      <div className="newsfeed-item__header">
        <img src={pageIcon} alt="Page Icon" className="newsfeed-item__page-icon" />
        <div className="newsfeed-item__title-wrapper">
          <h4 className="newsfeed-item__title">{pageName}</h4>
          <p className="newsfeed-item__subtitle">{subtitle}</p>
        </div>
      </div>
      <div className="newsfeed-item__body">{body}</div>
      <div className="newsfeed-item__media">
        {children ||
          (isVideo ? (
            <video
              disablePictureInPicture
              autoPlay
              muted
              loop
              controls
              controlsList="mediaSrc"
              src={mediaSrc}
              data-testid="video"
              className="newsfeed-item__media-element"
              onLoadedData={() => {
                setIsLoaded(true);
              }}
            />
          ) : (
            <img
              src={mediaSrc}
              onLoad={() => {
                setIsLoaded(true);
              }}
              alt="Media Content"
              data-testid="image"
              className="newsfeed-item__media-element"
            />
          ))}
        <div
          id={`placeholder-${uuid}`}
          className="newsfeed-item--loading"
          style={{ display: isLoaded ? "none" : "block" }}
        />
      </div>
      <div className="newsfeed-item__description">
        <div className="newsfeed-item__description-domain">{domain}</div>
        <div className="newsfeed-item__description-title">{title}</div>
        <div className="newsfeed-item__description-message">{message}</div>
      </div>
      <div className="newsfeed-item__footer">
        <div className="newsfeed-item__stats">
          <span className="newsfeed-item__likes" />
          <span className="newsfeed-item__shares">10 Shares</span>
        </div>
      </div>
    </div>
  );
};

NewsFeedItem.propTypes = propTypes;

export default NewsFeedItem;
